import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { "element-loading-text": "正在提交数据，请稍后" }
const _hoisted_2 = { style: {"margin-bottom":"20px","text-align":"right"} }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("刷新")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("上传文件")
const _hoisted_5 = { style: {"display":"flex","justify-content":"center","align-items":"center"} }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 预览 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 编辑 ")
const _hoisted_8 = { class: "el-dropdown-link" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 文件下载 ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("删除附件")
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "el-upload__text" }, [
  /*#__PURE__*/_createTextVNode(" 拖动文件到此处"),
  /*#__PURE__*/_createElementVNode("em", null, "上传")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, " 允许上传文件类型：pdf文档,office文档,图像(jpg,jpeg,bmp) ", -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("关闭")

import { ref, reactive, unref } from 'vue';
import { useRouter } from 'vue-router'
import { ElMessage, ElForm, UploadFile, FormRules } from 'element-plus';
import { More } from '@element-plus/icons-vue';
import { GbTables } from "@/components/GbTables"
import { GbDialog } from '@/components/GbDialog/Index';
import { TableColumn } from '../../GbTables/GbTablesTypes';
import { config } from '@/config/config'
import { propTypes } from '@/utils/propTypes';
import { useGbTable } from '@/hooks/useGbTable'
import { useAppStore } from '@/store/app'
import { GetMaterialsApi, DelMaterialsApi, CheckMaterialApi, FileDownloadApi } from '../../../apis/materials/material.api';
import type { MaterialListDto, MaterialSearch, MaterialUploadDto } from '../../../apis/materials/material.dto';
import PdfViewDialog from './components/pdfViewDialog.vue'
import moment from 'moment';


export default /*#__PURE__*/_defineComponent({
  props: {
    isPreview: propTypes.bool.def(false),
    showUpload: propTypes.bool.def(true)
},
  setup(__props, { expose }) {

const props = __props



/* GbTable 配置 */
const { register, tableObject, methods } = useGbTable<any>({
    getListApi: GetMaterialsApi,
    delListApi: DelMaterialsApi,
    response: { data: 'data', total: 'total' }
})

const { base_url } = config
const { resolve } = useRouter()
const { setSearchParams } = methods

const login = useAppStore().getLoginInfo
const showDialog = ref<boolean>(false)
const uploadRef = ref<ComponentRef<typeof ElForm>>()
const pdfViewRef = ref<InstanceType<typeof PdfViewDialog>>()

/* 文件上传URL，请求头，上传数据列表 */
const actionUrl = `${base_url}/api/sysmaterial/uploadfile`;
const upHeaders = ref<Record<string, string>>({ "Authorization": `Bearer ${login.token}` })

const uploadSchema = ref<MaterialUploadDto>({
    categroy_id: '0afff935-9ffa-4907-8ce8-a8bf3463b41e',
    ct_num: '',
    material_type: '',
    material_type_desc: ''
})

/* 表单验证规则 */
const formRules = reactive<FormRules>({
    doc_title: [{ required: true, message: '文档名称不能留空', trigger: 'blur' }],
    material_type: [{ required: true, message: '请选择文件类型', trigger: 'blur' }],
})

/* 数据表查询条件 */
const search = reactive<MaterialSearch>({
    category_id: '0afff935-9ffa-4907-8ce8-a8bf3463b41e',
    current: 1,
    page_size: 10
})

/* 数据Table绑定设置 */
const tabColumns = reactive<TableColumn[]>([
    { field: 'file_name', label: '文件名称' },
    { field: 'material_type_desc', label: '分类', columnWidth: "120" },
    { field: 'file_suffix', label: '文件类型', columnWidth: "120" },
    { field: 'file_size', label: '文件大小', columnWidth: "120" },
    { field: 'curr_version', label: '当前版本', columnWidth: "80", align: 'center' },
    { field: 'created_user_id', label: '上传用户', columnWidth: "120", align: 'center' },
    { field: 'created_time', label: '上传时间', columnWidth: "120", align: 'center' },
    { field: 'action', width: '180px', label: "操作", fixed: 'right', align: 'center' }
])

const typeSelectList = ref<SelectItem[]>([
    { name: "合同正本", value: "ba6dba70-f3f1-4ee5-bd02-47850f416b60" },
    { name: "补充协议", value: "1f6a5f46-fd00-4387-a7fc-ab0bd4d5d437" },
    { name: "其他附件", value: "853735aa-8d47-4ea5-967f-8a1e50228835" },
])

const actions = {
    showEdit: (row: any) => {
        if (row && row.file_suffix) {
            return ['.doc', '.docx', 'text', '.xls', 'xlsx'].indexOf(row.file_suffix) > 0
        }
        else {
            return false
        }
    },

    /* 文件预览 */
    showPreview: (row: any) => {

        /* .pdf文件避免使用OnlyOffice打开，因为pdf文件有可能引发不可预料的错误 */
        if (row.file_suffix != '.pdf') {

            /* 如果是office系文件，则使用onlyoffice打开 */
            const isOfficeFile = ['.doc', '.docx', 'text', '.xls', 'xlsx'].indexOf(row.file_suffix) > 0
            if (isOfficeFile) {
                let urls = resolve({ path: `/document/docview`, query: { rowId: row.id, device: 1 } })
                window.open(urls.href, "_blank")
            } else {

            }
        } else {
            unref(pdfViewRef)?.openDialog(row);
        }
    },
    docEditor: (item: any) => {
        let urls = resolve({ path: `/document/doceditor`, query: { rowId: item.id, device: 1 } })
        window.open(urls.href, "_blank")
    }
}

const files = {
    /* 上传成功 */
    onUploadSuccess: (res: IResponse, file: UploadFile) => {
        if (!res.succeeded) {
            ElMessage.error(`文件上传失败，可能的原因是：${res.errors}`)
        } else {
            ElMessage.success("上传成功")
            tableObject.tableList.push(res.data);
        }
    },
    /* 文件下载 */
    onDownloadBtnClick: (fileId: string, name: string) => {
        if (!fileId) ElMessage.warning('找不到文件')

        /* 先检查文件 */
        CheckMaterialApi(fileId).then(async res => {

            if (!res.succeeded) {
                ElMessage.warning(`操作失败，可能的原因是：${res.errors}`)
            } else {
                if (res.data == false) {
                    ElMessage.error(`文件不存在`);
                } else {

                    /* 调用下载接口 */
                    const response = await FileDownloadApi(fileId)
                    const downloadLink = document.createElement('a');

                    downloadLink.href = window.URL.createObjectURL(response.data);
                    downloadLink.download = name
                    downloadLink.click();

                    window.URL.revokeObjectURL(downloadLink.href);
                }
            }
        })
    }
}

/* 内部方法 */
const func = {

    /* 删除数据 */
    deleteAction: async (row: MaterialListDto) => {
        await methods.deleteRows({ id: row.id, revision: row.revision })
    },

    /* 刷新数据 */
    reFresh: () => {
        unref(search).current = 1
        unref(search).page_size = 10

        setSearchParams(search)
    },

    /* 获取附件数据 */
    getData: (rowId: string, ctCode: string) => {
        unref(search).relation_id = rowId || ''
        unref(uploadSchema).ct_id = rowId || "10000000-0000-0000-0000-000000000001"
        unref(uploadSchema).ct_num = ctCode || ''

        setSearchParams(search)
    },

    /* 获取新增文档Id列表(TypeId为Null) */
    getFilesIds: (): string[] => {
        const fileIds: string[] = tableObject.tableList
            .filter((mt: MaterialListDto) => { return mt.rel_id == '10000000-0000-0000-0000-000000000001' })
            .map((mt: MaterialListDto) => {
                return mt.id
            })

        return fileIds;
    },
}

/* 选择文件类型 */
const onTypeChange = (item: SelectItem) => {
    unref(uploadSchema).material_type = item.value
    unref(uploadSchema).material_type_desc = item.name
}

expose({ func })

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_upload_filled = _resolveComponent("upload-filled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_button_group, { size: "small" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              icon: "RefreshRight",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (func.reFresh()))
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            (__props.showUpload)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  icon: "Plus",
                  type: "primary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (showDialog.value = true))
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _createVNode(_unref(GbTables), {
        pageSize: _unref(tableObject).pageSize,
        "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((_unref(tableObject).pageSize) = $event)),
        currentPage: _unref(tableObject).currentPage,
        "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => ((_unref(tableObject).currentPage) = $event)),
        columns: _unref(tabColumns),
        data: _unref(tableObject).tableList,
        pagination: { total: _unref(tableObject).total },
        onRegister: _unref(register)
      }, {
        curr_version: _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(`ver ${row.curr_version}.0`), 1)
        ]),
        created_time: _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(_unref(moment)(row.created_time).format('YYYY-MM-DD HH:mm')), 1)
        ]),
        action: _withCtx(({ row }) => [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_button, {
              icon: "Search",
              type: "primary",
              link: "",
              onClick: ($event: any) => (actions.showPreview(row))
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 2
            }, 1032, ["onClick"]),
            (actions.showEdit(row))
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  icon: "EditPen",
                  type: "success",
                  link: "",
                  onClick: ($event: any) => (actions.docEditor(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_dropdown, {
              style: {"padding":"2px","margin-left":"12px"},
              trigger: "click"
            }, {
              dropdown: _withCtx(() => [
                _createVNode(_component_el_dropdown_menu, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_dropdown_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "info",
                          link: "",
                          onClick: ($event: any) => (files.onDownloadBtnClick(row.id, row.file_name))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_9
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1024),
                    (!props.isPreview)
                      ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                          key: 0,
                          divided: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              type: "danger",
                              link: "",
                              onClick: ($event: any) => (func.deleteAction(row))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_10
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024)
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_8, [
                  _createVNode(_unref(More), { style: {"width":"1em","height":"1em","margin-right":"8px"} })
                ])
              ]),
              _: 2
            }, 1024)
          ])
        ]),
        _: 1
      }, 8, ["pageSize", "currentPage", "columns", "data", "pagination", "onRegister"])
    ])), [
      [_directive_loading, _unref(tableObject).loading]
    ]),
    _createVNode(_unref(GbDialog), {
      modelValue: showDialog.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((showDialog).value = $event)),
      title: "上传文件",
      style: {"width":"500px"}
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "info",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (showDialog.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(ElForm), {
          model: uploadSchema.value,
          ref_key: "uploadRef",
          ref: uploadRef,
          "label-width": "100px",
          rules: _unref(formRules),
          "label-position": 'right'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "文件类型",
              prop: "material_type"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: uploadSchema.value.material_type_desc,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((uploadSchema.value.material_type_desc) = $event)),
                  style: {"width":"100%"},
                  onChange: onTypeChange
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeSelectList.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.name,
                        value: item
                      }, null, 8, ["label", "value"]))
                    }), 256))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"]),
        _createVNode(_component_el_upload, {
          drag: "",
          multiple: "",
          data: uploadSchema.value,
          action: actionUrl,
          headers: upHeaders.value,
          "show-file-list": false,
          "on-success": files.onUploadSuccess
        }, {
          tip: _withCtx(() => [
            _hoisted_12
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_icon, { class: "el-icon--upload" }, {
              default: _withCtx(() => [
                _createVNode(_component_upload_filled)
              ]),
              _: 1
            }),
            _hoisted_11
          ]),
          _: 1
        }, 8, ["data", "headers", "on-success"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(PdfViewDialog, {
      ref_key: "pdfViewRef",
      ref: pdfViewRef
    }, null, 512)
  ], 64))
}
}

})